//  Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved.
/* eslint-disable require-jsdoc */

export class FeatureStoreInfo implements IFeatureStoreInfo {
	itemType: 'Experiment' | 'FeatureFlag';
	featureId: string;
	value?: string;
	featureName?: string;
	loadExperimentEveryTime?: boolean;

	constructor(dto: IFeatureStoreInfo) {
		this.itemType = dto.itemType;
		this.featureId = dto.featureId;
		this.value = dto.value;
		this.featureName = dto.featureName;
		this.loadExperimentEveryTime = dto.loadExperimentEveryTime;
	}
}

export class Experiment implements IExperiment {
	variant: string;
	isLoaded: boolean;
	isEnabled: boolean;
	feature: FeatureStoreInfo;

	constructor(dto: IFeatureStoreInfo) {
		this.variant = '';
		this.isLoaded = false;
		this.isEnabled = false;
		this.feature = dto;
	}
}

export default {
	FeatureStoreInfo,
	Experiment,
};
